import cn from '@/lib/cn';
import BrandGradient from './BrandGradient';
import Icon, { iconNames } from './Icon';

export default function BoundedIcon({
  background,
  className = undefined,
  name,
  size,
}: {
  /** Color scheme of the element */
  background: 'beige' | 'brand-gradient' | 'blue-opaque' | 'gray' | 'white';
  /** Additional CSS class(es) for the element */
  className?: string;
  /** Name / identifier of the icon */
  name: (typeof iconNames)[number];
  /** Size of the element */
  size: 'xs' | 'sm' | 'md' | 'lg';
}) {
  const sizeClassesMap = {
    lg: 'size-10 rounded-sm',
    md: 'size-9 rounded-sm',
    sm: 'size-6 rounded-xs',
    xs: 'size-4.5 rounded-xs',
  };

  const iconSizeClassesMap = {
    lg: 'size-6',
    md: 'size-5',
    sm: 'size-3.5',
    xs: 'size-2.5',
  };

  const backgroundClassesMap = {
    beige: 'bg-warm-gray-80 text-deep-blue-10',
    'blue-opaque': 'bg-deep-blue-90 text-deep-blue-20',
    'brand-gradient': 'text-white',
    gray: 'bg-neutral-95 text-neutral-10',
    white: 'bg-white/10 text-white',
  };

  return (
    <span
      className={cn(
        'flex items-center justify-center',
        {
          'relative isolate overflow-hidden': background === 'brand-gradient',
        },
        sizeClassesMap[size],
        backgroundClassesMap[background],
        className,
      )}
    >
      <Icon
        className={iconSizeClassesMap[size]}
        name={name}
      />

      {background === 'brand-gradient' && <BrandGradient />}
    </span>
  );
}
